import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import Button from '../Button/Button.js';

/* Component used for selecting filters, for example filtering stores in AAB. */ const FilterButton = (_param)=> {
    var { caption , isSelected  } = _param, buttonProps = swcHelpers.objectWithoutProperties(_param, [
        "caption",
        "isSelected"
    ]);
    return React.createElement(Button, swcHelpers.extends({
        className: classnames('filter-button', {
            'filter-button--is-selected': isSelected,
            'filter-button--is-deselected': !isSelected
        }),
        caption: caption
    }, buttonProps));
};

export { FilterButton as default };
//# sourceMappingURL=FilterButton.js.map
